import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { pricingActions } from '..';
import { PricingActions, PricingSubscriptionDataState } from '../types';

const initialPricingState: PricingSubscriptionDataState = {
  data: null,
  error: null,
  isError: false,
  isPending: false
};

const pricingSubscriptionDataReducer: Reducer<
  typeof initialPricingState,
  PricingActions
> = (state = initialPricingState, action) => {
  switch (action.type) {
    case getType(pricingActions.fetchPricingSubscriptionDataAsync.request): {
      return {
        ...state,
        isError: false,
        isPending: true
      };
    }
    case getType(pricingActions.fetchPricingSubscriptionDataAsync.success): {
      const { payload: pricingData } = action;

      return {
        ...state,
        data: { ...state.data, ...pricingData },
        isError: false,
        isPending: false
      };
    }
    case getType(pricingActions.fetchPricingSubscriptionDataAsync.failure): {
      const { payload: newError } = action;

      return {
        ...state,
        error: newError,
        isError: true,
        isPending: false
      };
    }
    default:
      return state;
  }
};

export default pricingSubscriptionDataReducer;
